import React, { useState, useEffect } from 'react';

import { Card, CardBody, Row, Spinner } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import * as acquisitionOrdersActions from '../../store/acquisitionOrders/actions';
import * as usersActions from '../../store/users/actions';
import DataTableNext from '../../components/Common/DataTable/DataTableNext';
import {
  CountRowTablePlacement,
  ExportButtonPlacement,
} from '../../components/Common/DataTable/tableActionButtons';
import {
  getFilter,
  getLabel,
  getSort,
  userName,
} from '../Common/DataTable/tableHelpers';
import { ExtraCallButton } from '../Common/DataTable/tableActionButtons';
import moment from 'moment';

const NextAppointments = ({ nextAppointments }) => {
  const acquisitionOrders = useSelector(
    (state) => state.AcquisitionOrder.acquisitionOrders,
  );
  const users = useSelector((state) => state.User.users);

  const loadingAcquisitionOrders = useSelector(
    (state) => state.AcquisitionOrder.loading,
  );
  const loadingUsers = useSelector((state) => state.User.loading);
  const loading = loadingAcquisitionOrders || loadingUsers;

  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(acquisitionOrdersActions.syncAcquisitionOrders());
    dispatch(usersActions.syncUsers());
  }, []);

  const handleStartCall = (row) => {
    window.open(`/calls/manage?phone=${row.phone.replace('+', '')}`, '_self');
  };

  const columns = [
    {
      title: 'Acquisition Order',
      name: 'acquisitionOrderId',
      width: 160,
      getCellValue: (row) =>
        getLabel(row.acquisitionOrderId, acquisitionOrders),
    },
    {
      title: 'Phone',
      name: 'phone',
      width: 140,
    },
    {
      title: 'Name',
      name: 'leadName',
    },
    {
      title: 'Appointment date',
      name: 'appointmentDate',
      width: 190,
      formatterComponent: ({ value }) =>
        value ? moment(value).format('DD/MM/YYYY HH:mm') : '',
      sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
      filter: (value, filter) =>
        getFilter(
          value ? moment(value).format('DD/MM/YYYY HH:mm') : '',
          filter.value,
        ),
    },
    {
      title: 'Appointment with',
      name: 'appointmentUserId',
      width: 160,
      getCellValue: (row) => userName(row.appointmentUserId, users),
    },
    {
      title: 'Action',
      name: 'action',
      width: 100,
      align: 'center',
      formatterComponent: ({ row }) => (
        <ul className="list-inline font-size-20 contact-links mb-0">
          <ExtraCallButton
            row={row}
            label="Start call"
            onPress={handleStartCall}
          />
        </ul>
      ),
      filter: 'disabled',
      sorting: 'disabled',
    },
  ];

  return (
    <Card>
      <CardBody>
        <Row className="align-items-center justify-content-end m-auto pb-2">
          <CountRowTablePlacement tableId="next-appointments" />
          <Spinner color="secondary" animation="border" hidden={!loading} />
          <ExportButtonPlacement tableId="next-appointments" />
        </Row>
        <DataTableNext
          loading={false}
          rows={nextAppointments}
          columns={columns}
          filters={filters}
          onFiltersChange={setFilters}
          sorting={sorting}
          onSortingChange={setSorting}
          selection={selection}
          onSelectionChange={setSelection}
          currentPage={currentPage}
          onCurrentPageChange={setCurrentPage}
          pageSize={pageSize}
          onPageSizeChange={setPageSize}
          tableId="next-appointments"
        />
      </CardBody>
    </Card>
  );
};

export default NextAppointments;
